module.exports = __webpack_public_path__ + "static/media/textlink.03555596.svg";